import theme from '@vromo/ui/components/theme';

export default {
    fleetTableItem: {
        backgroundColor: 'white',
        marginBottom: 8,
        paddingTop: 8,
        paddingBottom: 8
    },
    tableItemContents: {
        flex: 1
    },
    checkboxContainer: {
        marginLeft: 12,
        paddingTop: 4
    },
    checkboxLabel: {
        marginLeft: 12,
        fontWeight: 'bold',
        color: theme.darkText
    },
    coverage: {
        flex: 1,
        marginLeft: 8,
        color: theme.darkText
    },
    detailsButtonContainer: {
        flex: 1,
        textAlign: 'right'
    },
    detailsButton: {
        textDecorationLine: 'underline',
        marginRight: 20,
        color: theme.text.dark
    }
};
